import { Component, Inject, Input } from '@angular/core';
import { WINDOW } from '@edassist/common';

@Component({
	selector: 'ea-review-applications-appeals',
	templateUrl: './review-application-appeal.component.html',
	styleUrls: ['./review-application-appeal.component.scss']
})
export class ReviewApplicationAppealComponent {
	@Input() bulkAppReviewCount = 0;
	private readonly BULK_REVIEW_PAGE_URL = '/tuition/review-applications';

	constructor(@Inject(WINDOW) private readonly window: Window) {}

	navigateToBulkReview(): void {
		this.window.location.href = this.BULK_REVIEW_PAGE_URL;
	}
}
